import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/cotton/admin/projectVersion';

export function insertProjectVersion(data) {
    return Post(baseUrl + '/insertProjectVersion', data);
}

export function updateProjectVersionById(data) {
    return Post(baseUrl + '/updateProjectVersionById', data);
}

export function updateProjectVersionCode(data) {
    return Post(baseUrl + '/updateProjectVersionCode', data);
}

export function deleteProjectVersionById(data) {
    return Post(baseUrl + '/deleteProjectVersionById', data);
}

export function queryProjectVersionList(data) {
    return Post(baseUrl + '/queryProjectVersionList', data);
}

export function queryAllChannel() {
    return Post(baseUrl + '/queryAllChannel', {});
}

export function queryDistinctAppIdAndGameName() {
    return Post(baseUrl + '/queryDistinctAppIdAndGameName', {});
}

export function queryDistinctProjectVersionList(data) {
    return Post(baseUrl + '/queryDistinctProjectVersionList', data);
}